
/* @flow */
/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

export const FETCH_PDP_DATA: string = 'FETCH_PDP_DATA';
export const FETCH_CATALOG_BANNERS_DATA: string = 'FETCH_CATALOG_BANNERS_DATA';
export const FETCH_THOR_CONNECTION_STATE: string = 'FETCH_THOR_CONNECTION_STATE';
export const CHECK_HAS_THOR: string = 'CHECK_HAS_THOR';
export const UPDATE_ENTITLED_PRODUCTS: string = 'UPDATE_ENTITLED_PRODUCTS';
export const UPDATE_PRODUCTS_POST_THOR_CHECK: string = 'UPDATE_PRODUCTS_POST_THOR_CHECK';
export const FETCH_APPS_CCXI_DATA: string = 'FETCH_APPS_CCXI_DATA';
export const FETCH_PDP_CCXI_DATA: string = 'FETCH_PDP_CCXI_DATA';
export const FETCH_FFC_ALL_VERSION_DATA: string = 'FETCH_FFC_ALL_VERSION_DATA';
export const FETCH_DATA_FOR_APP_PICKER: string = 'FETCH_DATA_FOR_APP_PICKER';
export const FETCH_SINGLE_APP_PLAN_CVS_DATA: string = 'FETCH_SINGLE_APP_PLAN_CVS_DATA';
export const FETCH_FFC_APP_PICKER_DATA: string = 'FETCH_FFC_APP_PICKER_DATA';
